import { render, staticRenderFns } from "./McsBaseComponent.vue?vue&type=template&id=5ccc1e4a&"
import script from "./McsBaseComponent.vue?vue&type=script&lang=js&"
export * from "./McsBaseComponent.vue?vue&type=script&lang=js&"
import style0 from "./McsBaseComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports